import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0f54ad58&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=0f54ad58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54ad58",
  null
  
)

export default component.exports